import store from '@/store'

const isAuthenticatedGuardClub = async (to, from, next) => {

    const {ok, message} = await store.dispatch('club/checkAuthentication')
    if(ok) next()
    else next({name: 'auth-club'})
}

export default isAuthenticatedGuardClub